/* eslint-disable no-console */
import { Trans } from '@lingui/react/macro';

import type { TVisitSummary } from '../../../../react-query/useVisitSummaries';
import { VideaLogoIcon } from '../../../../svgs/videaLogoIcon';
import { useRecommendedProceduresGroupedByMouthArea } from '../patientStripOdontogram/hooks';

import { SheetTxProceduresInfo } from './SheetTxProceduresInfo';

interface OpportunitiesProps {
  visitSummary: TVisitSummary | undefined;
}

const Opportunities: React.FC<OpportunitiesProps> = ({ visitSummary }) => {
  const groupedRecommendations =
    useRecommendedProceduresGroupedByMouthArea(visitSummary);
  const displayGroupedRecommendations = Object.entries(groupedRecommendations);
  const hasAddressedRecommendation = displayGroupedRecommendations.some(
    ([, procedures]) => procedures?.some(({ isAddressed }) => isAddressed),
  );

  return (
    <div className="vai-px-4 vai-relative">
      <div className="vai-text-white vai-text-[16px] vai-gap-[8px] vai-py-[4px] vai-px-[10px] vai-w-fit vai-bg-navy-500 vai-rounded-full vai-flex vai-flex-row vai-items-center vai-mb-[-15px] vai-relative vai-z-10">
        <VideaLogoIcon />
        <p className="vai-font-thin">
          <Trans>Opportunities</Trans>
        </p>
      </div>
      <div
        className="vai-border vai-rounded-[8px] vai-border-zinc-400  vai-py-[10px] vai-px-[10px] vai-mx-1 vai-relative vai-z-0"
        data-testid="opportunities-container"
      >
        {displayGroupedRecommendations.length ? (
          displayGroupedRecommendations.map(([affectedArea, procedures]) => (
            <SheetTxProceduresInfo
              key={affectedArea}
              affectedArea={affectedArea}
              procedures={procedures}
            />
          ))
        ) : (
          <p className="vai-text-muted-foreground vai-text-sm vai-pt-3 vai-pb-2">
            <Trans>AI hasn&apos;t identified any opportunities</Trans>
          </p>
        )}

        {hasAddressedRecommendation && (
          <p className="vai-text-sm">
            &#42;{' '}
            <Trans>Addressed by a scheduled or completed treatment.</Trans>
          </p>
        )}
      </div>
    </div>
  );
};

export default Opportunities;
